import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const HoverBox = styled(Box)`
  ${props => (props.disabled
    ? ''
    : `&:hover {
          background: #333;
          span {
          color: #fff;
          }
          svg {
            fill: #fff;
          }
        }
      `)}
`

export default HoverBox
